export const config = {
  backendUrl: process.env.REACT_APP_BACKEND_URL as string,
  passwordResetUrl: process.env.REACT_APP_PASSWORD_RESET_URL as string
}
